import axios from 'axios'
import { getApiUrl } from '@/config/api'

const BASE = '/api/DocEmpresaConfig'
const _cache = {}

export default {
  async leer() {
    const key = 'actual'
    if (_cache[key]) return _cache[key]
    const res = await axios.get(getApiUrl(BASE))
    const data = res.data || { EmpresaId: 0, Items: [] }
    _cache[key] = data
    return data
  },

  async leerDocumento(tipoDocumento) {
    const key = `doc-${tipoDocumento}`
    if (_cache[key]) return _cache[key]
    const res = await axios.get(getApiUrl(`${BASE}/${encodeURIComponent(tipoDocumento)}`))
    _cache[key] = res.data || null
    return _cache[key]
  },

  async leerAdmin(empresaId) {
    const res = await axios.get(getApiUrl(`${BASE}/admin?empresaId=${Number(empresaId) || 0}`))
    return res.data || { EmpresaId: empresaId, Items: [] }
  },

  async guardar(lista) {
    const res = await axios.post(getApiUrl(`${BASE}/guardar`), lista)
    this.invalidar()
    return res.data
  },

  async eliminar(configId) {
    const res = await axios.post(getApiUrl(`${BASE}/eliminar/${configId}`))
    this.invalidar()
    return res.data
  },

  async resetEmpresa(empresaId) {
    const res = await axios.delete(getApiUrl(`${BASE}/admin/empresa/${Number(empresaId) || 0}`))
    this.invalidar()
    return res.data
  },

  async duplicarGlobal(empresaId) {
    const res = await axios.post(getApiUrl(`${BASE}/admin/empresa/${Number(empresaId) || 0}/duplicar-global`))
    this.invalidar()
    return res.data
  },

  invalidar() {
    Object.keys(_cache).forEach(k => delete _cache[k])
  }
}
